import { render, staticRenderFns } from "./addAccess.vue?vue&type=template&id=6e41b898&scoped=true"
import script from "./addAccess.vue?vue&type=script&lang=js"
export * from "./addAccess.vue?vue&type=script&lang=js"
import style0 from "./addAccess.vue?vue&type=style&index=0&id=6e41b898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e41b898",
  null
  
)

export default component.exports